// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"107efff2","455":"31539d39","977":"212aa7f2"}[chunkId] + ".chunk.js";
};